(function($) {
    let docBody = $(document.body);
    function throttle(func, wait, options) {
        var timeout, context, args, result;
        var previous = 0;
        if (!options) options = {};
      
        var later = function () {
          previous = options.leading === false ? 0 : Date.now();
          timeout = null;
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        };
      
        var throttled = function () {
          var _now = Date.now();
          if (!previous && options.leading === false) previous = _now;
          var remaining = wait - (_now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0 || remaining > wait) {
            if (timeout) {
              clearTimeout(timeout);
              timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
          } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      
        throttled.cancel = function () {
          clearTimeout(timeout);
          previous = 0;
          timeout = context = args = null;
        };
      
        return throttled;
    }

    let previousScrollPosition = 0;

    const isScrollingDown = () => {
        let goingDown = false;

        let scrollPosition = window.pageYOffset;

        if (scrollPosition > previousScrollPosition) {
            goingDown = true;
        }

        previousScrollPosition = scrollPosition;

        return goingDown;
    };

    let mainNav = $('#main-nav'), mainNavHeight = mainNav.height();

    const handleScroll = () => {
        let offsetTop = parseInt(mainNav.offset().top);
        if (isScrollingDown()) {
            offsetTop < mainNav.height()|| mainNav.addClass("floating scroll-down").removeClass("scroll-up");
        } else {
            if (parseInt(mainNav.offset().top) < mainNavHeight){
                mainNav.removeClass('scroll-down scroll-up floating');
            } else {
                mainNav.removeClass("scroll-down").addClass('scroll-up');
            }
        }
    };

    const scrollThrottle = throttle(handleScroll, 100);
    var waypoint = new Waypoint.Sticky({
        element: mainNav[0],
        handler: (dir) => {
            console.log('Basic waypoint triggered', dir);
        }
    })
    window.addEventListener("scroll", scrollThrottle);
    if (docBody.hasClass('home')){
        const publicBanner = new Swiper('#public-banner', {
            navigation: {
                nextEl: '.banner-swiper-next',
                prevEl: '.banner-swiper-prev',
            },
            pagination: {
                el: '.swiper-pagination'
            }
        });
        const whySwiper = new Swiper('#reason-swiper', {
            // Navigation arrows
            slidesPerView: "auto",
            spaceBetween: 40,
            navigation: {
                nextEl: '.reason-next',
                prevEl: '.reason-prev',
            },
        });
        const certSwiper = new Swiper('#certificate-swiper', {
            // Navigation arrows
            slidesPerView: "auto",
            spaceBetween: 40,
            navigation: {
                nextEl: '.certificate-next',
                prevEl: '.certificate-prev',
            },
        });
        $(document).on('hover mouseover', '.solution-item', (e) => {
            let $el = $(e.currentTarget), img = $el.data('img');
            $el.closest('.home-solutions').css('background-image', 'url("'+img+'")');
        })
    }
    if (docBody.hasClass('tax-product_cat')){
        const publicBanner = new Swiper('#category-banner', {
            navigation: {
                nextEl: '.banner-swiper-next',
                prevEl: '.banner-swiper-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    }
    $(document).on('click', '.fold-title', (e) => {
        let $elem = $(e.currentTarget);
        $elem.closest('.fold-panel').toggleClass('expand');
    });
    $(document).ready(function(){
        $('#main-menu').superfish({
            onBeforeShow: () => {
                mainNav.addClass('show');
            },
            onBeforeHide: (el) => {
                mainNav.removeClass('show');
            }
        });
    });
})(jQuery);